<template>
  <div class="event workout" :class="{'undone': workout.workout_done === false, 'done': workout.workout_done === true}">
    <div class="event-header">
      <span class="event-date">{{ workout.datetime.date() }}</span>
      <span class="event-name" :class="'style-' + workout.style">{{ workout.workout_type }}</span>
      <span class="event-actions">
        <v-icon dark class="click-effect" v-if="isActiveRunnerTrainer" v-tooltip="'Edytuj'" @click.stop="$emit('edit-workout')">edit</v-icon>
        <v-icon dark class="click-effect" v-if="isActiveRunnerTrainer" v-tooltip="'Usuń'" @click.stop="$emit('remove-workout')">delete</v-icon>
      </span>
    </div>
    <div v-if="!micro" class="event-content">
      <workout-elements v-if="workout.total_distance_done === null" :workout="workout"></workout-elements>
      <done-workout-elements v-else :workout="workout"></done-workout-elements>
    </div>
    <div class="event-footer">
      <span>
        <span v-tooltip="'Suma kilometrów'"><v-icon>mdi-sigma</v-icon>{{workout.total_distance_done || (workout.workout_done === false ? 0 : workout.total_distance_planned)}} km</span>
        <span v-if="workout.additional_info" v-tooltip="workout.additional_info"><v-icon>info</v-icon></span>
      </span>
      <span>
        <v-icon class="click-effect" v-if="(isActiveRunner || isActiveRunnerTrainer) && workout.workout_done !== true" v-tooltip="'Trening wykonany'" @click.stop="$emit('done-workout')">done</v-icon>
        <v-icon class="click-effect" v-if="(isActiveRunner || isActiveRunnerTrainer) && workout.workout_done !== false" v-tooltip="'Trening niewykonany'" @click.stop="$emit('undone-workout')">clear</v-icon>
      </span>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import WorkoutElements from './WorkoutElements'
import DoneWorkoutElements from './DoneWorkoutElements'

export default {
  components: {WorkoutElements, DoneWorkoutElements},
  props: {
    workout: {
      type: Object,
      required: true
    },
    micro: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['isActiveRunnerTrainer', 'isActiveRunner'])
  }
}
</script>



// WEBPACK FOOTER //
// src/plan/WorkoutSmall.vue